import type { SupplierRequestDraftItem } from './types';

interface BuildSupplierRequestPdfParams {
    t: (key: string, options?: Record<string, unknown>) => string;
    vendorName: string;
    note: string;
    items: SupplierRequestDraftItem[];
    generatedAt: number;
}

export const buildSupplierRequestPdfDefinition = ({
    t,
    vendorName,
    note,
    items,
    generatedAt,
}: BuildSupplierRequestPdfParams) => {
    const issuedDate = new Date(generatedAt).toLocaleString('uk-UA');
    const noteText = String(note || '').trim();

    const tableBody = [
        [
            { text: t('supplierRequests.pdf.colNo'), style: 'tableHeader' },
            { text: t('supplierRequests.pdf.colName'), style: 'tableHeader' },
            { text: t('supplierRequests.pdf.colArticle'), style: 'tableHeader' },
            { text: t('supplierRequests.pdf.colCount'), style: 'tableHeader', alignment: 'right' },
        ],
        ...items.map((item, index) => [
            String(index + 1),
            item.prodName || `#${item.productId}`,
            item.prodArticle || '—',
            { text: String(item.itemCount), alignment: 'right' },
        ]),
    ];

    return {
        pageSize: 'A4',
        pageMargins: [36, 36, 36, 36],
        defaultStyle: {
            fontSize: 10,
        },
        content: [
            { text: t('supplierRequests.pdf.title'), style: 'title' },
            { text: '\n' },
            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            { text: `${t('supplierRequests.pdf.vendorLabel')}: ${vendorName || '—'}` },
                            { text: `${t('supplierRequests.pdf.dateLabel')}: ${issuedDate}` },
                        ],
                    },
                ],
            },
            { text: '\n' },
            { text: t('supplierRequests.pdf.intro'), margin: [0, 0, 0, 12] },
            {
                table: {
                    headerRows: 1,
                    widths: [28, '*', 90, 60],
                    body: tableBody,
                },
                layout: 'lightHorizontalLines',
            },
            ...(noteText
                ? [
                      { text: '\n' },
                      { text: t('supplierRequests.pdf.noteLabel'), style: 'sectionTitle' },
                      { text: noteText },
                  ]
                : []),
        ],
        styles: {
            title: {
                fontSize: 16,
                bold: true,
            },
            sectionTitle: {
                fontSize: 11,
                bold: true,
                margin: [0, 0, 0, 6],
            },
            tableHeader: {
                bold: true,
                fillColor: '#f3f5f7',
            },
        },
    };
};
